import React, { createContext, useContext, useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage";

interface AuthContextType {
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return !!secureLocalStorage.getItem("jwt"); // Check if JWT exists
  });

  useEffect(() => {
    // Sync state with storage
    const jwt = secureLocalStorage.getItem("jwt");
    setIsAuthenticated(!!jwt);
  }, []);

  const login = (token: string) => {
    secureLocalStorage.setItem("jwt", token); // Store JWT securely
    setIsAuthenticated(true);
  };

  const logout = () => {
    secureLocalStorage.removeItem("jwt"); // Remove JWT
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to access AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
